


















































































import {Component, Vue} from 'vue-property-decorator';
// @ts-ignore
import {Slide} from 'vue-burger-menu';
import {LoginInfo} from '@/store/auth/auth.types';
import {AuthEnum} from '@/store/auth/auth.enum';

@Component({
  components: {
    Slide
  }
})
export default class SlideBarComponents extends Vue {

  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
  public isLogin = false;
  public current = '/';

  async mounted() {
    this.isLogin = !!(this.loginInfo);

    let router = this.$router as any;
    let serviceType = this.$route.query.serviceType || '';
    this.current = router.history.current.path + serviceType;
  }

  async logOut() {
    localStorage.removeItem(AuthEnum.Auth);
    localStorage.removeItem(AuthEnum.weakPassword);
    await this.$router.push('/');
  }

  reloadPage() {
    location.reload();
  }
}
